import { getAllowPopups } from "global/cnr/reducers/ItemReducer"
import { getFirstObject } from "global/common/convert"
import { SettingsViewerContext } from "global/components/viewers/FullSettingsViewer"
import { gEnums } from "global/enums/globalEnums"
import { useContext } from "react"
import { ammendIcons, getProps_viewItem } from "../contextHelpers/ammendUiItem"
import { DataContext } from "../DataContext"
import { FilterContext } from "../FilterContext"
import { PageAreaContext } from "../PageAreaContext"
import { PageAreaParentContext } from "../PageAreaParentContext"
import { ParentContext } from "../ParentContext"

import { useAppAccessPermissions } from "./useAppAccessPermissions"
import { useDataModifications } from "./useDataModifications"
import { useNavigationOptions } from "./useNavigationOptions"
import { useViewItemSettings } from "./useViewItemSettings"
import { useViewItemStatus } from "./useViewItemStatus"

export const useItemInit = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { appUsers_state, paps_state, page_state, currentSettings_state } = states
  const { view, viewKey } = paps_state ?? {}
  const { aps_global, aps_viewItems, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { appAccess, desktop, display: display_global, groupingOptions, imageOptions } = aps_global ?? {}
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { appAccessType } = appAccess ?? {}

  let isPublicSite = false

  switch (appAccessType) {
    case gEnums.siteAuthorizationTypes.public:
    case gEnums.siteAuthorizationTypes.passcode:
      isPublicSite = true
      break;
    default:
    // nothing
  }

  const pageAreaParentContext = useContext(PageAreaParentContext)
  const { states: parent_states_p } = pageAreaParentContext ?? {}
  const { framework_state } = parent_states_p ?? {}

  const { desktopMode, tempSettings } = framework_state ?? {}

  const _tempSettings_vi = tempSettings && tempSettings[uivi]
  const { display: display_temp } = _tempSettings_vi ?? {}

  const { showDefaultIconsInDisplay, showDefaultIconsInDisplayIfNull, defaultIconColor } = display_global ?? {}

  const viewItem_g = aps_viewItems ? aps_viewItems[view] : null
  const { dataFilters, props: props_vig } = viewItem_g ?? {}

  const { appUserProfiles } = appUsers_state ?? {}
  const { itemWrapType } = desktop ?? {}

  const settingsViewerContext = useContext(SettingsViewerContext)
  const { settingsViewer_state } = settingsViewerContext ?? {}
  const { viewItem_preview } = settingsViewer_state ?? {}

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}

  // dataContext
  const dataContext = useContext(DataContext);
  const { data_state } = dataContext ?? {}
  const { isCombinedData, uivi, viewListData, viewListDataCount, time_stamp, alphabetValue } = data_state ?? {}

  const filterContext = useContext(FilterContext);
  const { uiFilter_state } = filterContext ?? {}
  const {
    alphabetActive,
    alphaValue,
    divideIntoGroups,
    filterSidebarOpen,
    filterStatusType,
    filterValues,
    groupDataProps,
    searchValue,
    selectedFilters,
  } = uiFilter_state ?? {}

  let viewItem = pageItemsShown ? pageItemsShown[uivi] : {}
  const { display, desktopDisplay, filter, search, grouping, images } = viewItem ?? {}

  let { layout, desktopLayout } = aps_page ?? {}
  const _layout = desktopMode ? desktopLayout : layout
  const { layoutType } = _layout

  let _display = desktopMode && desktopDisplay ? desktopDisplay : display
  if (display_temp) { _display = display_temp }

  const { showSearch, searchOnPage } = search ?? {}
  const { showFilter } = filter ?? {}

  const { caption, displayType, cardDisplayType, showExtra, extraDisplayType, showExtraInternal } = _display ?? {}

  const viewItem_key = viewItem ? viewItem.key : null

  const { item: _dataItem } = viewListData ? getFirstObject(viewListData) : {}
  const dataItemCount = viewListData ? Object.keys(viewListData).length : 0

  const viewItemStatus = useViewItemStatus({ uivi })

  const { name, firstName, lastName, email } = _dataItem ?? {}
  const dataName = lastName ? firstName + ' ' + lastName : name

  const { showOverview, appUserOverviewPages } = aps_appUserSettings ?? {}

  if (showOverview && appUserProfiles && appUserProfiles[email]) {
    const appUserProfile = appUserProfiles[email]
    const { bio, aboutMe, appUserPrivacy } = appUserProfile ?? {}
    const { hideBioFromApp, hideAboutMeFromApp } = appUserPrivacy ?? {}
    if (!hideAboutMeFromApp && appUserOverviewPages.includes(gEnums.appUserProfilePageTypes.appUserAboutMe) && aboutMe) { _dataItem.aboutMe = aboutMe }
    if (!hideBioFromApp && appUserOverviewPages.includes(gEnums.appUserProfilePageTypes.appUserBio) && bio) { _dataItem.bio = bio }
    if (appUserOverviewPages.includes(gEnums.appUserProfilePageTypes.appUserGallery)) { _dataItem.gallery = 'gallery' }
  }

  const navOptions = useNavigationOptions({
    accessRequests: null,
    view,
    viewItem,
    viewKey,
  })

  const { _dataModificationOpts, dmOpts } = useDataModifications()

  const props_viewItem = getProps_viewItem(viewItem, viewListData, props_vig)
  ammendIcons(props_vig, props_viewItem, aps_viewItems, defaultIconColor, showDefaultIconsInDisplay, showDefaultIconsInDisplayIfNull)

  const _accessPrms = useAppAccessPermissions()

  let allowAppUserEdit;
  if (_accessPrms.validateAccess_eventUserPage()) { allowAppUserEdit = true }

  const _allowPopups = getAllowPopups(layoutType, filterStatusType, viewItem_preview)

  const viOpts = {
    propGroups: getPropGroups(props_viewItem),
    _groupingOpts: getGroupOptions(viewItem_key, grouping, groupingOptions, viewItemStatus, viewListDataCount),
    _imageOpts: getImageOptions(viewItem_key, viewKey, images, imageOptions),
  }

  // if (uivi === 'sessions') {
  //   console.group('useItemInit')
  //   console.log('isViewItemSubList', viewItemStatus?.isViewItemSubList)
  //   console.log('grouping', grouping)
  //   console.log('groupingOptions', groupingOptions)
  //   console.log('viOpts', viOpts)
  //   console.groupEnd()
  // }

  const { groups } = groupDataProps ?? {}

  const _pageOpts = { _display, itemWrapType, layout, layoutType }
  const _viewItemOpts = { caption, displayType, cardDisplayType, showExtra, extraDisplayType, showExtraInternal, searchOnPage, showFilter, showSearch }
  const _dataOpts = { alphabetValue, isCombinedData, time_stamp, uivi, viewListData }
  const _filterOpts = {
    alphaValue, alphabetActive, divideIntoGroups, filterSidebarOpen, filterStatusType,
    filterValues, groups, searchValue, selectedFilters, dataFilters,
  }

  const initOther = useViewItemSettings({ viewItem, propGroups: viOpts?.propGroups, itemData: _dataItem, _display })

  // if (uivi === 'sessions' && _.isEmpty(viOpts?._groupingOpts)) {
  //   console.group('useItemInit', uivi)
  //   console.log('viOpts', viOpts)
  //   console.groupEnd()
  // }


  return {
    ...viOpts,
    _dataModificationOpts,
    _display,
    _filterOpts,
    _pageOpts,
    _viewItemOpts,
    allowAppUserEdit,
    allowPopups: _allowPopups,
    dataItemCount,
    dataName,
    dataOpts: _dataOpts,
    dmOpts,
    itemData: _dataItem,
    navOptions,
    props_viewItem,
    viewItemStatus,
    ...initOther
  }

}

const getPropGroups = (props_viewItem) => {

  const getProper = (option, altOption) => {
    const propArray = []
    const props = altOption ? _.filter(props_viewItem, i => ((i[option] === true) && (i[altOption] !== true))) : _.filter(props_viewItem, { [option]: true })
    if (props) { props.forEach(i => propArray.push(i.key)) }
    return {
      props,
      propArray
    }
  }

  const getProperNamed = () => {
    const propArray = []
    const props = _.filter(props_viewItem, i => i.propSection === 'name' && i.tagged === true);
    if (props) { props.forEach(i => propArray.push(i.key)) }
    return {
      props,
      propArray
    }
  }

  const getProperTagged = () => {
    const propArray = []
    const props = _.filter(props_viewItem, i => i.propSection !== 'name' && i.tagged === true);
    if (props) { props.forEach(i => propArray.push(i.key)) }
    return {
      props,
      propArray
    }
  }

  const getProperSchedule = () => {
    const propArray = []
    const props = _.filter(props_viewItem, i => ((i.key === 'startDate') || (i.key === 'endDate') || (i.key === 'startTime') || (i.key === 'endTime')));
    if (props) { props.forEach(i => propArray.push(i.key)) }
    return {
      props,
      propArray
    }
  }

  const getAllArrays = () => {
    let _allArrays = []
    Object.keys(propGroups).forEach(key => {
      switch (key) {
        case 'header':
        case 'meta':
        case 'pin':
        case 'schedule':
        case 'tagged':
          if (propGroups[key] && propGroups[key].propArray) {
            _allArrays = [..._allArrays, ...propGroups[key].propArray]
          }
          break;
        default:
        // nothing
      }
    })
    return _allArrays
  }

  const propGroups = {
    admin: getProper(gEnums.menuItemOptionTypes.admin),
    schedule: getProper(gEnums.menuItemOptionTypes.schedule),
    header: getProper(gEnums.menuItemOptionTypes.header),
    meta: getProper(gEnums.menuItemOptionTypes.meta),
    pin: getProper(gEnums.menuItemOptionTypes.pin),
    show: getProper(gEnums.menuItemOptionTypes.show),
    tagged: getProperTagged(gEnums.menuItemOptionTypes.tagged),
    address: getProperTagged(gEnums.menuItemOptionTypes.address),
    contact: getProperTagged(gEnums.menuItemOptionTypes.contact),
    propArrays: []
  }

  if (propGroups && propGroups.header && propGroups.header.propArray.length === 0) { propGroups.header = getProperNamed() }
  if (propGroups && propGroups.schedule && propGroups.schedule.propArray.length === 0) { propGroups.schedule = getProperSchedule() }

  propGroups.propArrays = getAllArrays()

  return propGroups
}

const getGroupOptions = (viKey, grouping, groupingOptions, viewItemStatus, viewListDataCount) => {

  const { isViewItemSolo, isViewItemList, isViewItemSubList } = viewItemStatus ?? {}
  const _isList = isViewItemList || isViewItemSubList

  const _groupingProps = ['groupType', 'orderGroupsByAlpha', 'useStartCaseHeaders']

  const { overrideAlphaSettings, overrideGroupSettings } = grouping ?? {}
  const { useGlobalAlphabetSettings, useGlobalGroupSettings, applyToCollections, alphaFilterType, alphaFilterAfter } = groupingOptions ?? {}

  const _alphaFilterAfter = alphaFilterAfter ? alphaFilterAfter : 50

  let _grouping = _.clone(grouping)

  if (useGlobalAlphabetSettings && !overrideAlphaSettings && applyToCollections && applyToCollections.includes(viKey) && _isList) {
    if (!_grouping) {
      _grouping = {
        origin: 'aui'
      }
    }
    switch (alphaFilterType) {
      case gEnums.alphaFilterTypes.afterLimit:
        _grouping.alphabetActive = viewListDataCount > _alphaFilterAfter
        break;
      default:
        _grouping.alphabetActive = true
    }
  }

  if (_grouping && groupingOptions) {
    if (useGlobalGroupSettings && !overrideGroupSettings) {
      Object.keys(_grouping).forEach(gKey => {
        if (_groupingProps.includes(gKey)) {
          _grouping[gKey] = groupingOptions[gKey] ? groupingOptions[gKey] : _grouping[gKey]
        }
      })
    }

    if (useGlobalAlphabetSettings && !overrideAlphaSettings) {
      Object.keys(groupingOptions).forEach(gKey => {
        if (!_groupingProps.includes(gKey)) {
          _grouping[gKey] = groupingOptions[gKey] ? groupingOptions[gKey] : _grouping[gKey]
        }
      })
    }
  }

  const _groupingOpts = { ..._grouping }

  return isViewItemSolo ? {} : _groupingOpts
}

const getImageOptions = (viKey, viewKey, images_viewItem, imageOptions) => {

  let _images_vi = _.clone(images_viewItem)

  const { overrideImageSettings } = _images_vi ?? {}
  const { useGlobalImageSettings, collectionImageCollections } = imageOptions ?? {}

  let _imageOptions = {}

  if (useGlobalImageSettings && collectionImageCollections && collectionImageCollections.includes(viKey) && !overrideImageSettings) {
    _imageOptions = overrideImageSettings ? _images_vi : imageOptions
    _imageOptions.showItemImage = true
  } else {
    _imageOptions = _images_vi
  }

  return _imageOptions
}
